module.exports = __webpack_public_path__ + "static/media/logo.4290b8c2.svg";